module.exports = __webpack_public_path__ + "img/yijujue.923e5c40.png";